/* global JSX */
import React, { CSSProperties } from 'react';

export enum Direction {
  Up,
  Down,
  Right,
  Left,
}

interface IProps {
  color?: CSSProperties['fill'];
  direction?: Direction;
  height?: CSSProperties['height'];
  width?: CSSProperties['width'];
  size?: CSSProperties['width'];
  style?: JSX.IntrinsicElements['svg']['style'];
}

const transform = (direction: Direction) => {
  switch (direction) {
    case Direction.Up:
      return 'rotate(180deg)';
    case Direction.Right:
      return 'rotate(-90deg)';
    case Direction.Left:
      return 'rotate(90deg)';
    default:
      return undefined;
  }
};

const ActionArrow = ({
  color = 'currentColor',
  direction = Direction.Down,
  height,
  size = '100%',
  style,
  width,
}: IProps) => {
  const w = width || size;
  const h = height || size;

  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 20 12"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: transform(direction), ...style }}
    >
      <polygon style={{ fill: color }} points="0,0 20,0 10,12" />
    </svg>
  );
};

export default ActionArrow;
